import { render } from "./Complaints.vue?vue&type=template&id=dbcbcaa8&scoped=true"
import script from "./Complaints.vue?vue&type=script&lang=js"
export * from "./Complaints.vue?vue&type=script&lang=js"

import "./css/style.css?vue&type=style&index=0&id=dbcbcaa8&scoped=true&lang=css"
import "./Complaints.vue?vue&type=style&index=1&id=dbcbcaa8&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbcbcaa8"]])

export default __exports__